import { render } from "./ObjectDetector.vue?vue&type=template&id=9c77afe0&scoped=true"
import script from "./ObjectDetector.vue?vue&type=script&lang=js"
export * from "./ObjectDetector.vue?vue&type=script&lang=js"

import "./ObjectDetector.vue?vue&type=style&index=0&id=9c77afe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c77afe0"]])

export default __exports__